import { DateTime } from "luxon";
import { Plan } from "./plan";

export class MasterPlan {
    id!: string;
    name!: string;
    description!: string;
    distributionLaneName!: string;
    distributionLaneId!: string;
    organizationUnitId?: string;
    timeZone!: string;
    offSet!: number;
    createdBy!: string;
    createdAt!: DateTime;
    modifiedAt!: DateTime
    plans!: Plan[];
    type!:number;
    additionalData?: Record<string, string>;
}